import { IFieldInstance } from "../../types/fieldInstance.interface";

export function transformForSubmit(
  values: any,
  fields: IFieldInstance[],
  incidentRelatedLists: any
) {
  // convert multiselects to semi-colon separated string
  // get all RLs
  // receives values, all fields, incident related lists
  // if field name contains multi, transform
  // if field name matches RL, set appropriate property to value
  const transformedData: any = {
    incident: {},
  };
  const relatedLists = Object.entries(incidentRelatedLists);
  const { RecordType, ...dataForSubmit } = values;
  const allValues = Object.entries(dataForSubmit);
  for (const [key, value] of allValues) {
    if (Array.isArray(value)) {
      const index = relatedLists.findIndex((row) => row.includes(key));
      const field = fields.find((field) => field.fieldName === key);
      if (index !== -1) {
        transformedData[relatedLists[index][0]] = value;
      } else if (field && field.fieldType.includes("Multi")) {
        transformedData.incident[key] = value.join(";");
      }
    } else {
      transformedData.incident[key] = value;
    }
  }
  return transformedData;
}

export const removeNonFormValues = (initialValues: any, draftValues: any) => {
  const initialValueKeys = Object.keys(initialValues);
  const draftValueKeys = Object.keys(draftValues);
  const commonKeys = draftValueKeys.filter((key) =>
    initialValueKeys.includes(key)
  );
  const result: any = {};
  commonKeys.forEach((key) => {
    result[key] = draftValues[key];
  });
  return result;
};
